import { render, staticRenderFns } from "./YourSpouse.vue?vue&type=template&id=5169567a"
import script from "./YourSpouse.vue?vue&type=script&lang=js"
export * from "./YourSpouse.vue?vue&type=script&lang=js"
import style0 from "./YourSpouse.vue?vue&type=style&index=0&id=5169567a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports